<div *ngIf="loading">
	<div *ngIf="current_info && ruolo != enum_ruoli.ostetrica">
		<nb-card>
			<nb-card-header>
				<h2>{{ current_info?.label.it }}</h2>
			</nb-card-header>
			<nb-card-body>
				<div class="info" [innerHTML]="current_info?.info.it"></div>

				<youtube-player
					*ngIf="youtube_code"
					class="mt-4"
					videoId="{{ youtube_code }}"
				></youtube-player>
			</nb-card-body>
		</nb-card>
	</div>
	<div *ngIf="ruolo == enum_ruoli.ostetrica && stats">
		<ngx-dashboard-ostetrica
			[stats]="stats"
			[auth_user]="auth_user"
		></ngx-dashboard-ostetrica>
	</div>
</div>

<!-- <app-test-tiny></app-test-tiny> -->
